// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"366ccb1a","327":"c3a71a48","492":"32774436","646":"a657dc41","667":"366ccb1a","724":"4617210f","836":"366ccb1a","942":"b2d22fb7"}[chunkId] + ".chunk.css";
};